module.exports = __webpack_public_path__ + "static/media/purpose.4ee27efd.svg";